module.exports = __webpack_public_path__ + "static/img/coupon_mashimashi.819e2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon_mashimashi.png
// module id = RJv6
// module chunks = 1